export default "__VITE_ASSET__BEtHmHhh__"